/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { CustomerAddressesModel } from '../data/models';

export default (
  data: CustomerAddressesModel[],
  selectShipping: boolean,
  selectBilling: boolean
): CustomerAddressesModel[] => {
  if (
    (selectShipping && selectBilling) ||
    (!selectShipping && !selectBilling)
  ) {
    return data;
  }

  const copyAddressList: CustomerAddressesModel[] = data.slice();

  if (selectShipping) {
    return copyAddressList.sort(
      (a, b) => Number(b.defaultShipping) - Number(a.defaultShipping)
    );
  }

  if (selectBilling) {
    return copyAddressList.sort(
      (a, b) => Number(b.defaultBilling) - Number(a.defaultBilling)
    );
  }

  return data;
};
